module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-1022w.3743f2ac.webp";